var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 59,
    viewBox: "0 0 77 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.9377 5.43859C74.316 10.0866 76.6672 15.3032 76.6672 23.7594C76.6672 38.6319 66.227 51.965 51.0371 58.5546L47.2431 52.6998C61.4182 45.0303 64.1883 35.0823 65.2959 28.8097C63.0136 29.99 60.0259 30.4047 57.0972 30.1336C49.4285 29.4226 43.3846 23.127 43.3846 15.3032C43.3846 7.08797 50.0443 0.428223 58.2596 0.428223C62.8202 0.428223 67.1812 2.51263 69.9377 5.43859ZM27.4377 5.43859C31.8161 10.0866 34.1672 15.3032 34.1672 23.7594C34.1672 38.6319 23.727 51.965 8.53715 58.5546L4.74321 52.6998C18.918 45.0303 21.6884 35.0823 22.7957 28.8097C20.5135 29.99 17.5259 30.4047 14.5971 30.1336C6.92856 29.4226 0.884766 23.127 0.884766 15.3032C0.884766 7.08797 7.54452 0.428223 15.7598 0.428223C20.3202 0.428223 24.6813 2.51263 27.4377 5.43859Z",
    fill: "#E41F76"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.a0f5d891c981d4c15026983b90faa119.svg";
export { ForwardRef as ReactComponent };